import { render, staticRenderFns } from "./SearchFilterColumnMenu.vue?vue&type=template&id=24712e9f&scoped=true"
import script from "./SearchFilterColumnMenu.vue?vue&type=script&lang=js"
export * from "./SearchFilterColumnMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24712e9f",
  null
  
)

export default component.exports